import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{attrs:{"row":"","fill-height":"","wrap":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","sm":"12","md":"5"}},[_c('flow-shell',{staticClass:"mr-3",attrs:{"flowName":this.$route.params.first}})],1),_c(VCol,{attrs:{"cols":"12","sm":"12","md":"5"}},[_c('flow-shell',{attrs:{"flowName":this.$route.params.second}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }